import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, TrendingUp, Clock, ArrowRight } from 'lucide-react';

const quickActions = [
  {
    label: 'Pengajuan Kredit',
    icon: FileText,
    link: '/credit/submission/new',
    color: 'bg-blue-500',
  },
  {
    label: 'Model Scoring',
    icon: TrendingUp,
    link: '/credit/scoring',
    color: 'bg-purple-500',
  },
  {
    label: 'Pending Approval',
    icon: Clock,
    link: '/credit/approval',
    color: 'bg-amber-500',
  },
];

export default function CreditQuickActions() {
  const navigate = useNavigate();

  return (
    <div className="bg-white border rounded-lg">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Akses Cepat</h3>
      </div>
      <div className="p-4 space-y-2">
        {quickActions.map(action => {
          const Icon = action.icon;
          return (
            <button
              key={action.link}
              onClick={() => navigate(action.link)}
              className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-8 h-8 rounded-lg ${action.color} flex items-center justify-center`}
                >
                  <Icon className="w-4 h-4 text-white" />
                </div>
                <span className="font-medium">{action.label}</span>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
